import { BallerineLogo } from '@/components/atoms/Icons/BallerineLogo';
import type { FunctionComponent } from 'react';

export const Maintenance: FunctionComponent = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-8 text-center">
      <BallerineLogo />
      <h1 className="text-3xl font-bold">Planned Maintenance</h1>
      <p className="text-base text-gray-500">
        Our system is temporarily offline for a scheduled update. We’ll be back shortly. Thanks for
        your patience!
      </p>
    </div>
  );
};
